"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./modals.module.css";
import DeleteModal from "./delete-modal";
import SoldModal from "./sold-modal";
import { useMyListingsStore } from "../../../useMyListingsStore";
import { useScrollLock } from "@/hooks/use-scroll-lock";
import { useDialogRouting } from "@/hooks/use-dialog-routing";

export default function DeleteModalWrapper() {
  const dialogRef = useRef<HTMLDivElement>(null);
  const { closeDeleteModal } = useMyListingsStore();
  const isDeleteModalOpen = useMyListingsStore(
    (state) => state.deleteState.isDeleteModalOpen,
  );
  const isSecondStep = useMyListingsStore(
    (state) => state.deleteState.isSecondStep,
  );

  useDialogRouting("DeleteModalWrapper", isDeleteModalOpen, closeDeleteModal);

  useScrollLock(isDeleteModalOpen);

  return (
    isDeleteModalOpen && (
      <div
        className={styles.modalWrapper}
        onClick={(e) => {
          e.stopPropagation();
          closeDeleteModal();
        }}
      >
        {!isSecondStep ? (
          <SoldModal dialogRef={dialogRef} handleClose={closeDeleteModal} />
        ) : (
          <DeleteModal dialogRef={dialogRef} handleClose={closeDeleteModal} />
        )}
      </div>
    )
  );
}
